import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeSnackbar } from './redux/actions/notifications';
import { RootStore } from 'redux/store';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

let displayed: any = [];

const Toast: React.FC = () => {
	const dispatch = useDispatch();
	const notifications = useSelector((state: RootStore) => state.notifications.notifications || []);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const storeDisplayed = (id: any) => {
		displayed = [...displayed, id];
	};

	const removeDisplayed = (id: any) => {
		displayed = [...displayed.filter((key: any) => id !== key)];
	};

	useEffect(() => {
		notifications.forEach(({ key, message, options = {}, dismissed = false }: any) => {
			if (dismissed) {
				// dismiss snackbar using notistack
				closeSnackbar(key);
				return;
			}

			// do nothing if snackbar is already displayed
			if (displayed.includes(key)) return;

			const action = (key: any) => (
				<div id={`toast-${key}`}>
					<IconButton
						aria-label="close"
						color="inherit"
						onClick={() => {
							closeSnackbar(key);
						}}
					>
						<CloseIcon fontSize="small" />
					</IconButton>
				</div>
			);

			// display snackbar using notistack
			enqueueSnackbar(message, {
				anchorOrigin: {
					vertical: 'bottom',
					horizontal: 'center',
				},
				key,
				action,
				...options,
				onClose: (event, reason, myKey) => {
					if (options.onClose) {
						options.onClose(event, reason, myKey);
					}
				},
				onExited: (event, myKey) => {
					// remove this snackbar from redux store
					dispatch(removeSnackbar(myKey));
					removeDisplayed(myKey);
				},
			});

			// keep track of snackbars that we've displayed
			storeDisplayed(key);
		});
	}, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

	return null;
};

export default Toast;
